"use strict";

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.string.bold");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports.MobileView = exports.WebView = exports.CategoryAndProductNameBox = exports.ProductPriceAndRatingBox = exports.RatingValue = exports.ProductInfo = exports.BrandLabel = exports.NotifDetails = exports.NotifImage = exports.NotifCardContainer = exports.PriceFormatter = exports.SoldOut = exports.TransparentOverlay = exports.FoldingRow = exports.RatingCount = exports.RatingContainer = exports.Decimal = exports.ActualPrice = exports.PriceSymbol = exports.PriceDisplay = exports.PriceContainer = exports.DiscountOff = exports.DiscountPercent = exports.DiscountAmount = exports.DiscountContainer = exports.AddToCartContainer = exports.ProductName = exports.CategoryName = exports.ProductDetails = exports.ProductImage = exports.OverImage = exports.ProductDetailDiscount = exports.ImageContainer = exports.ProductCardContainer = exports.CardText = exports.CardImageOverlay = exports.CardImage = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _theme = _interopRequireDefault(require("./theme"));

var _containers = require("./containers");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject37() {
  var data = _taggedTemplateLiteralLoose(["\n  display: none;\n  @media (max-width: 767px) {\n    display: contents;\n  }\n"]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteralLoose(["\n  display: contents;\n  @media (max-width: 767px) {\n    display: none;\n  }\n"]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 1.2rem;\n  color: #6b6c6f;\n  letter-spacing: 0.4px;\n  line-height: 1.8rem;\n"]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 1.2rem;\n  color: #aeaeae;\n  letter-spacing: 0.4px;\n  line-height: 1.8rem;\n  display: flex;\n  flex-direction: row;\n"]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 1rem;\n  line-height: 1.8rem;\n  color: #aeaeae;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n  font-weight: 600;\n"]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteralLoose(["\n  max-width: 12rem;\n  max-height: 12rem;\n"]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: 4px;\n  font-size: 1.4rem;\n  color: #ffffff;\n  text-align: center;\n  line-height: 22px;\n  background-color: #000;\n  width: auto;\n  position: relative;\n  left: -50%;\n  padding: 0.3rem 0.8rem;\n"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: #fff;\n  height: 100%;\n  opacity: 0.5;\n"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteralLoose(["\n  @media (max-width: 767px) {\n    flex-direction: column;\n  }\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 1rem;\n  color: #6b6c6f;\n  letter-spacing: 0.05rem;\n  text-align: center;\n  line-height: 1.2rem;\n  margin: 0 0.8rem;\n  border: 0.1rem solid ", ";\n  padding: 0rem 0.8rem;\n  border-radius: 2rem;\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-top: -0.2rem;\n  @media (min-width: 768px) {\n    margin-top: 0;\n  }\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 12px;\n  color: ", ";\n  letter-spacing: 0.4px;\n  line-height: 18px;\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteralLoose(["\n  letter-spacing: 0.1rem;\n  color: ", ";\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  text-decoration: ", ";\n  font-size: ", ";\n  letter-spacing: 0;\n  text-align: right;\n  font-weight: 600;\n  color: ", ";\n\n  @media (max-width: 768px) {\n    font-size: ", ";\n  }\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  padding: 0.5em 0 0 0;\n  flex-direction: column;\n  flex-wrap: wrap;\n  @media (max-width: 550px) {\n    flex-direction: column;\n    padding: 0.4em 0;\n  }\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 1.2rem;\n  color: #ffffff;\n  font-weight: 600;\n  padding-left: 0.5rem;\n  align-self: center;\n  @media (max-width: 767px) {\n    align-self: flex-end;\n    font-weight: 400;\n    padding-left: 0.3rem;\n    font-size: 1rem;\n    line-height: 1rem;\n  }\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 1.2rem;\n  color: #ffffff;\n  font-weight: 400;\n  align-self: center;\n  @media (max-width: 767px) {\n    align-self: flex-start;\n    font-size: 1.2rem;\n    line-height: 1.2rem;\n  }\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 1.2rem;\n  color: #ffffff;\n  font-weight: 700;\n  align-self: flex-end;\n  @media (max-width: 767px) {\n    font-size: 1.2rem;\n    line-height: 1.2rem;\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n  width: fit-content;\n  padding: 0.5rem 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  background-color: ", ";\n  position: absolute;\n  bottom: 2rem;\n  right: 1rem;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n  max-width: 5.5rem;\n  max-height: 4.8rem;\n  width: 5.5rem;\n  height: 4.8rem;\n  border-top-left-radius: 1.6rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 1.2rem;\n  font-weight: 500;\n  @media (min-width: 768px) {\n    font-size: 1.6rem;\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  font-weight: 700;\n  color: #aeaeae;\n  margin-bottom: 0.4rem;\n  @media (min-width: 768px) {\n    font-size: 1rem;\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: #fff;\n  padding: 0.8rem;\n  max-width: 24rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 14rem;\n  @media (max-width: 768px) {\n    height: 12rem;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  max-height: 32rem;\n  max-width: 24rem;\n  width: 100%;\n  pointer-events: none;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n      animation-name: beat;\n      animation-duration: 1.5s;\n      animation-iteration-count: infinite;\n      animation-timing-function: ease;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: ", ";\n  right: ", ";\n  top: ", ";\n  bottom: ", ";\n  width: ", ";\n  height: ", ";\n  z-index: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n\n  @keyframes beat {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(0.5);\n  }\n}\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: #f4364c;\n  color: #fff;\n  padding: 0.5rem;\n  /* border-top-left-radius: 0.6rem;\n  border-bottom-left-radius: 0.6rem; */\n  font-size: 1.2rem;\n\n  @media (max-width: 767px) {\n    font-size: 1rem;\n    padding: 0.3rem 0.3rem 0.3rem 0.4rem;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  max-width: 24rem;\n  max-height: 32rem;\n  position: relative;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  max-width: 24rem;\n  max-height: 45.7rem;\n  overflow: hidden;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  line-height:  ", ";\n  flex-direction: row;\n  font-weight: ", ";\n  margin: 0px;\n  font-size: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  @media (max-width: 550px) {\n    ", "\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  display: flex;\n  margin: 0;\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  display: flex;\n  margin: 0;\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var CardImage = _styledComponents["default"].img(_templateObject(), function (props) {
  return props.height ? "height: " + props.height + ";" : "";
}, function (props) {
  return props.width ? "width: " + props.width + ";" : "";
}, function (props) {
  return props.hasOpacity ? "opacity: 50%;" : "";
});

exports.CardImage = CardImage;

var CardImageOverlay = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.height ? "height: " + props.height + ";" : "";
}, function (props) {
  return props.width ? "width: " + props.width + ";" : "";
});

exports.CardImageOverlay = CardImageOverlay;

var CardText = _styledComponents["default"].div(_templateObject3(), function (props) {
  return props.lineHeight ? props.lineHeight : "1.6";
}, function (props) {
  return props.fontWeight ? props.fontWeight : props.bold ? "700" : "400";
}, function (props) {
  return props.xlarge ? "25px" : props.large ? "18px" : props.small ? "12px" : props.size || "15px";
}, function (props) {
  return props.alignItems ? "align-items:" + props.alignItems + ";" : "";
}, function (props) {
  return props.fontWeight ? "font-weight:" + props.fontWeight + ";" : "";
}, function (props) {
  return props.fontStyle ? "font-style:" + props.fontStyle + ";" : "";
}, function (props) {
  return props.textDecoration ? "text-decoration:" + props.textDecoration + ";" : "";
}, function (props) {
  return props.textTransform ? "text-transform:" + props.textTransform + ";" : "";
}, function (props) {
  return props.letterSpacing ? "letter-spacing:" + props.letterSpacing + ";" : "";
}, function (props) {
  return props.rightAlign ? "text-align: right;" : props.center ? "text-align: center;" : "";
}, function (props) {
  return props.color ? "color: " + props.color + ";" : "";
}, function (_ref) {
  var mobileViewSize = _ref.mobileViewSize;
  return mobileViewSize ? "font-size: " + (mobileViewSize === "xlarge" ? "25px" : mobileViewSize === "large" ? "18px" : mobileViewSize === "small" ? "12px" : mobileViewSize === "default" ? "15px" : mobileViewSize) + ";" : "";
});

exports.CardText = CardText;

var ProductCardContainer = _styledComponents["default"].div(_templateObject4());

exports.ProductCardContainer = ProductCardContainer;

var ImageContainer = _styledComponents["default"].div(_templateObject5());

exports.ImageContainer = ImageContainer;

var ProductDetailDiscount = _styledComponents["default"].div(_templateObject6());

exports.ProductDetailDiscount = ProductDetailDiscount;

var OverImage = _styledComponents["default"].div(_templateObject7(), function (props) {
  return props.position == "upper-left" || props.position == "bottom-left" ? props.padding : "auto";
}, function (props) {
  return props.position == "upper-right" || props.position == "bottom-right" ? props.padding : 0;
}, function (props) {
  return props.position == "upper-left" || props.position == "upper-right" ? props.padding : "auto";
}, function (props) {
  return props.position == "bottom-left" || props.position == "bottom-right" ? props.padding : 0;
}, function (props) {
  return props.width || "max-content";
}, function (props) {
  return props.height || "max-content";
}, function (props) {
  return props.zIndex || "20";
}, function (props) {
  return props.top && "top: " + props.top + ";";
}, function (props) {
  return props.bottom && "bottom: " + props.bottom + ";";
}, function (props) {
  return props.left && "left: " + props.left + ";";
}, function (props) {
  return props.right && "right: " + props.right + ";";
}, function (props) {
  return props.animate && (0, _styledComponents.css)(_templateObject8());
});

exports.OverImage = OverImage;

var ProductImage = _styledComponents["default"].img(_templateObject9());

exports.ProductImage = ProductImage;

var ProductDetails = _styledComponents["default"].div(_templateObject10());

exports.ProductDetails = ProductDetails;

var CategoryName = _styledComponents["default"].div(_templateObject11());

exports.CategoryName = CategoryName;

var ProductName = _styledComponents["default"].div(_templateObject12());

exports.ProductName = ProductName;

var AddToCartContainer = _styledComponents["default"].div(_templateObject13(), _theme["default"]["default"].secondarySky25P);

exports.AddToCartContainer = AddToCartContainer;

var DiscountContainer = _styledComponents["default"].div(_templateObject14(), _theme["default"]["default"].secondaryPomegranate);

exports.DiscountContainer = DiscountContainer;

var DiscountAmount = _styledComponents["default"].div(_templateObject15());

exports.DiscountAmount = DiscountAmount;

var DiscountPercent = _styledComponents["default"].div(_templateObject16());

exports.DiscountPercent = DiscountPercent;

var DiscountOff = _styledComponents["default"].div(_templateObject17());

exports.DiscountOff = DiscountOff;

var PriceContainer = _styledComponents["default"].div(_templateObject18());

exports.PriceContainer = PriceContainer;

var PriceDisplay = _styledComponents["default"].div(_templateObject19(), function (props) {
  return props.isDiscount ? "line-through" : "none";
}, function (props) {
  return props.isDiscount ? "1.5rem" : "2rem";
}, function (props) {
  return props.isDiscount ? _theme["default"]["default"].secondaryPomegranate : "";
}, function (props) {
  return props.isDiscount ? "1rem" : "1.6rem";
});

exports.PriceDisplay = PriceDisplay;

var PriceSymbol = _styledComponents["default"].div(_templateObject20(), function (props) {
  return !props.isDiscount ? "#000" : _theme["default"]["default"].secondaryPomegranate;
});

exports.PriceSymbol = PriceSymbol;

var ActualPrice = _styledComponents["default"].div(_templateObject21(), function (props) {
  return !props.isDiscount ? "#000" : _theme["default"]["default"].secondaryPomegranate;
});

exports.ActualPrice = ActualPrice;

var Decimal = _styledComponents["default"].div(_templateObject22(), function (props) {
  return props.hasDiscount ? _theme["default"]["default"].secondaryPomegranate : _theme["default"]["default"].grey;
});

exports.Decimal = Decimal;

var RatingContainer = _styledComponents["default"].div(_templateObject23());

exports.RatingContainer = RatingContainer;

var RatingCount = _styledComponents["default"].div(_templateObject24(), _theme["default"]["default"].grey50P);

exports.RatingCount = RatingCount;
var FoldingRow = (0, _styledComponents["default"])(_containers.FlexRow)(_templateObject25());
exports.FoldingRow = FoldingRow;

var TransparentOverlay = _styledComponents["default"].div(_templateObject26());

exports.TransparentOverlay = TransparentOverlay;

var SoldOut = _styledComponents["default"].div(_templateObject27());

exports.SoldOut = SoldOut;

var PriceFormatter = function PriceFormatter(props) {
  return /*#__PURE__*/_react["default"].createElement(PriceDisplay, {
    isDiscount: props.isDiscount
  }, /*#__PURE__*/_react["default"].createElement(PriceSymbol, {
    isDiscount: props.isDiscount,
    hasDiscount: props.hasDiscount
  }, "P"), /*#__PURE__*/_react["default"].createElement(ActualPrice, {
    isDiscount: props.isDiscount,
    hasDiscount: props.hasDiscount
  }, props.price));
};

exports.PriceFormatter = PriceFormatter;

var NotifCardContainer = _styledComponents["default"].div(_templateObject28());

exports.NotifCardContainer = NotifCardContainer;

var NotifImage = _styledComponents["default"].img(_templateObject29());

exports.NotifImage = NotifImage;

var NotifDetails = _styledComponents["default"].div(_templateObject30());

exports.NotifDetails = NotifDetails;

var BrandLabel = _styledComponents["default"].div(_templateObject31());

exports.BrandLabel = BrandLabel;

var ProductInfo = _styledComponents["default"].div(_templateObject32());

exports.ProductInfo = ProductInfo;

var RatingValue = _styledComponents["default"].div(_templateObject33());

exports.RatingValue = RatingValue;

var ProductPriceAndRatingBox = _styledComponents["default"].div(_templateObject34());

exports.ProductPriceAndRatingBox = ProductPriceAndRatingBox;

var CategoryAndProductNameBox = _styledComponents["default"].div(_templateObject35());

exports.CategoryAndProductNameBox = CategoryAndProductNameBox;

var WebView = _styledComponents["default"].div(_templateObject36());

exports.WebView = WebView;

var MobileView = _styledComponents["default"].div(_templateObject37());

exports.MobileView = MobileView;